import { CommonModule, KeyValue } from '@angular/common';
import {
  Component,
  ChangeDetectionStrategy,
  Input,
  Output,
  EventEmitter,
  OnInit
} from '@angular/core';
import { NullableString } from '@models/app.models';
import { TabComponent } from './tab/tab.component';

@Component({
  selector: 'app-tabs',
  standalone: true,
  imports: [CommonModule, TabComponent],
  templateUrl: './tabs.component.html',
  styleUrls: ['./tabs.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TabsComponent implements OnInit {
  ngOnInit(): void {
    // using ng-content instead of tab list
    if (!this.tabs) {
      return;
    }
    this.activeTab ??= Object.keys(this.tabs)[0];
  }
  @Input() activeTab?: NullableString;
  @Input() tabs?: { [key: string]: string };
  @Output() tabClick = new EventEmitter<string>();

  get lastTabIndex(): number {
    // using ng-content instead of tab list
    if (!this.tabs) {
      return 0;
    }
    return Object.keys(this.tabs).length - 1;
  }

  getTabKey(_idx: number, { key }: KeyValue<string, string>): string {
    return key;
  }
}
